import React from 'react';

import { Chat as UIChat } from '@vk-hr-tek/ui/Chat';
import { loadChat, selectStatus } from '@vk-hr-tek/core/chat';

import { useDispatch, useSelector } from '@app/hooks';
import { useIsQuizRoute } from '@app/hooks/useIsQuizRoute';

export const Chat = () => {
  const dispatch = useDispatch();
  const isQuizRoute = useIsQuizRoute();

  const status = useSelector(selectStatus);

  const loadWebim = () => dispatch(loadChat());

  // Не показываем чат на страницах опросов
  if (isQuizRoute) {
    return null;
  }

  return (
    <UIChat
      status={status}
      loadWebim={loadWebim}
      webimAccountName={window.REACT_APP_VKHRTEK_WEBIM_ACCOUNT_NAME}
    />
  );
};
